import { render, staticRenderFns } from "./TableContext.vue?vue&type=template&id=18d945f9&scoped=true"
import script from "./TableContext.vue?vue&type=script&lang=js"
export * from "./TableContext.vue?vue&type=script&lang=js"
import style0 from "./TableContext.vue?vue&type=style&index=0&id=18d945f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d945f9",
  null
  
)

export default component.exports